import { InjectionToken } from "@angular/core";

// http://stackoverflow.com/a/40287063
export let role = new InjectionToken("role");

export interface Role {
    webUser: string;
    webAdmin: string;
    internalStaff: string;
}

export const Role: Role = {
    webUser: "WebUser",
    webAdmin: "WebAdmin",
    internalStaff: "InternalStaff"
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/core/role.const.ts